<template
  src="./index.html"
  lang="html"></template>
<style
  src="../../stylus/main.css"
  lang="css">
  </style>

<script>
export default {
  computed: {
    isSpanish() {
      return this.$i18n.locale.localeCompare('es') === 0;
    },
    isEnglish() {
      return this.$i18n.locale.localeCompare('en') === 0;
    }
  },
  methods: {
    setLanguage(lang) {
      this.$i18n.locale = lang;
    }
  }
}
</script>